import type { HearingLossAudiologistConsultData } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsult/hearingLossAudiologistConsult';
import { CustomControlCode } from '@common/enums';
import { hearingLossAudiologistConsultSections } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsult/hearingLossAudiologistConsult';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { HearingLossAudiologistConsultEdit } from './HearingLossAudiologistConsultEdit';
import { HearingLossAudiologistConsultRead } from './HearingLossAudiologistConsultRead';

CustomControlRegistry.instance.register<HearingLossAudiologistConsultData>({
    EditElement: () => <HearingLossAudiologistConsultEdit sections={hearingLossAudiologistConsultSections} />,
    ReadElement: () => <HearingLossAudiologistConsultRead />,
    code: CustomControlCode.HearingLossAudiologistConsult,
    version: 1,
});
